import { addDays } from '../utils/dates.ts';

export type Account = {
  attendeeUid: string;
  eventCode: string;
  eventLogo: string;
  name: string;
  email: string;
  phoneNumber: string;
  regDate: Date;
  expiredDate: Date | null;
};

export const makeAccount = ({
  attendeeUid,
  eventCode,
  eventLogo = '',
  name = '',
  email = '',
  phoneNumber = '',
  regDate,
  expiredDate = null,
}: {
  attendeeUid: string;
  eventCode: string;
  eventLogo: string;
  name: string;
  email: string;
  phoneNumber: string;
  regDate: string | Date;
  expiredDate: string | Date | null;
}): Account => ({
  attendeeUid,
  eventCode,
  eventLogo,
  name,
  email,
  phoneNumber,
  regDate: new Date(regDate),
  expiredDate: expiredDate ? new Date(expiredDate) : null,
});

export const calculateExpiredDate = (event: { photo_auto_delete_days: number }, attendee: { created_date: Date }) =>
  event.photo_auto_delete_days ? addDays(attendee.created_date, event.photo_auto_delete_days) : null;
